module.exports = __webpack_public_path__ + "static/write-for-us-68bdb10ea0e126232a9d456d9dadda6a.svg";